module.exports = ({ durations, timingFunctions }) => ({ addUtilities }) => {
  const newUtilities = {
    // Properties
    '.transition-property': {
      'transition-property': 'opacity, transform, height, width'
    },
    '.will-change': {
      'will-change': 'opacity, transform, height, width'
    }
  }

  // Transitions
  for (let timing in timingFunctions) {
    newUtilities[`.timing-${timing}`] = {
      'transition-timing-function': timingFunctions[timing]
    }
  }

  // Durations
  for (let duration in durations) {
    newUtilities[`.duration-${duration}`] = {
      'transition-duration': durations[duration]
    }
  }

  addUtilities(newUtilities)
}
